export const setAreasToSelect = (value) =>
  sessionStorage.setItem("areas", JSON.stringify(value));
export const getAreasToSelect = () =>
  JSON.parse(sessionStorage.getItem("areas"));
